import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../api/generic/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHFormulaType = SearchDataTableType({
	request: BaseRequest({
		sortFields: constants.wholeHouse.formula.sortFields,
		columnFields: constants.wholeHouse.formula.columnFields,
		standardFilterFields: constants.wholeHouse.formula.osStandardFilterFields,
		dateFilterFields: constants.wholeHouse.formula.osDateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
	columnFields: constants.wholeHouse.formula.columnFields,
	filterIds: constants.wholeHouse.formula.filterFields,
});
